export default {
  name: {
    ppg: 'Aplikasi PPG',
    gurupenggerak: 'Aplikasi Guru Penggerak',
  },
  singkat: {
    ppg: 'PPG',
    gurupenggerak: 'Guru Penggerak',
  },
  lblTypeProfil: {
    ppg: 'Data Profil',
    gurupenggerak: 'Data Profil',
  },
  lblTypeLengkap: {
    ppg: 'Data Pelengkap',
    gurupenggerak: 'Data Pelengkap',
  },
  lblTypePendidikan: {
    ppg: 'Riwayat Pendidikan Tinggi',
    gurupenggerak: 'Riwayat Pendidikan Tinggi',
  },
  lblTypePendidikanDaljab: {
    ppg: 'Riwayat Pendidikan Tinggi',
    gurupenggerak: 'Riwayat Pendidikan Tinggi',
  },
  lblTypeKeahlian: {
    ppg: 'Bidang Keahlian (Termasuk: Pendidik PGSD/ Prestasi/ Karya Monumental/ Kompetensi Bidang Lainnya)',
    gurupenggerak: 'Bidang Keahlian',
  },
  lblTypeKerja: {
    ppg:
      'Pengalaman Kerja/Jabatan (<b>WAJIB</b> diisi untuk <b>DOSEN LPTKP</b>, <b>TIDAK WAJIB</b> untuk <b>PRAKTISI PENDIDIKAN</b>)',
    gurupenggerak: 'Pengalaman Kerja/Jabatan',
  },
  lblTypePelatihan: {
    ppg: 'Pelatihan/Training/Workshop',
    gurupenggerak: 'Pelatihan/Training/Workshop',
  },
  lblTypeAjar: {
    ppg: 'Pengalaman Mengajar',
    gurupenggerak: 'CV - Asal Institusi',
  },
  lblTypeOrganisasi: {
    ppg: 'Pengalaman Organisasi',
    gurupenggerak: 'CV - Pengalaman Beroganisasi',
  },
  lblTypeBerkas: {
    ppg: 'Persyaratan Berkas',
    gurupenggerak: 'Persyaratan Berkas',
  },
  lblTypePimpinan: {
    ppg: 'Surat Izin Pimpinan',
    gurupenggerak: 'Surat Izin Pimpinan',
  },
  lblTypeKomitmen: {
    ppg: 'Surat Pernyataan Mengikuti Program',
    gurupenggerak: 'Surat Pernyataan Mengikuti Program',
  },
  lblTypePamong: {
    ppg: 'SK/Sertifikat/Bukti lainnya sebagai guru pamong dari Perguruan Tinggi',
    gurupenggerak: 'SK/Sertifikat/Bukti lainnya sebagai guru pamong dari Perguruan Tinggi',
  },
  lblTypeCv: {
    ppg: 'Berkas Daftar Riwayat Hidup',
    gurupenggerak: 'Berkas Daftar Riwayat Hidup',
  },
  lblTypeEsai: {
    ppg: 'Penjabaran Esai',
    gurupenggerak: 'Penjabaran Esai',
  },
  lblTypeInovasi: {
    ppg: `Berkas yang membuktikan memiliki kepakaran khusus minimal bertaraf nasional untuk Penerapan model
            pembelajaran inovatif jenjang SD/Hak cipta media pembelajaran inovatif jenjang SD/penulis buku ajar jenjang
            SD/Trainer pembelajaran jenjang SD`,
    gurupenggerak: `Berkas yang membuktikan memiliki kepakaran khusus minimal bertaraf nasional untuk Penerapan model
            pembelajaran inovatif jenjang SD/Hak cipta media pembelajaran inovatif jenjang SD/penulis buku ajar jenjang
            SD/Trainer pembelajaran jenjang SD`,
  },
  lblTypeMutu: {
    ppg: `Berkas yang membuktikan kegiatan meningkatkan mutu pembelajaran jenjang SD; Pernah memiliki
            pengalaman mengajar/melatih guru`,
    gurupenggerak: `Berkas yang membuktikan kegiatan meningkatkan mutu pembelajaran jenjang SD; Pernah memiliki
            pengalaman mengajar/melatih guru`,
  },
  lblTypeKompetensi: {
    ppg: `Berkas yang membuktikan pengakuan kelayakan kompetensi dari institusi Kementerian Pendidikan dan
            Kebudayaan atau institusi lain yang memiliki kerjasama internasional`,
    gurupenggerak: `Berkas yang membuktikan pengakuan kelayakan kompetensi dari institusi Kementerian Pendidikan dan
            Kebudayaan atau institusi lain yang memiliki kerjasama internasional`,
  },
  lblTypePgsd: {
    ppg: `Berkas yang membuktikan memiliki keahlian dan prestasi terkait pengajaran bidang PGSD`,
    gurupenggerak: `Berkas yang membuktikan memiliki keahlian dan prestasi terkait pengajaran bidang PGSD`,
  },
  lblTypeDasar: {
    gurupenggerak: 'CV - Informasi Dasar',
  },
  lblTypeMentoring: {
    gurupenggerak: 'CV - Pengalaman Mentoring',
  },
  lblTypeSertifikasi: {
    gurupenggerak: 'CV - Sertifikasi',
  },
  lblTypeKemampuan: {
    gurupenggerak: 'CV - Kemampuan yang dikuasai',
  },
  lblBiodata: {
    k_propinsi: 'Provinsi dari Alamat Rumah',
    k_kota: 'Kota dari Alamat Rumah',
    no_hp: 'Nomor Telepon Seluler',
    alamat: 'Alamat Rumah',
    kodepos: 'Kodepos Rumah',
    nik: 'NIK',
    rekening_nama: 'Nama Pemilik Rekening',
    rekening_bank: 'Nama Bank',
    rekening_cabang: 'Nama Cabang Bank',
    rekening_nomor: 'Nomor Rekening',
    instansi_asal: 'Nama Instansi',
    instansi_k_propinsi: 'Provinsi dari Alamat Instansi',
    instansi_k_kota: 'Kota dari Alamat Instansi',
    instansi_alamat: 'Alamat Instansi',
    instansi_kodepos: 'Kodepos Instansi',
    pendidikan: 'Latar Belakang Pendidikan / Program Studi',
    k_jabatan_dosen_ppg: 'Jabatan Fungsional',
    k_jabatan_guru: 'Jabatan Fungsional',
  },
};
